/**
 * Serviço de Escolas (Unidades Escolares)
 *
 * Gerencia operações CRUD de escolas usando PostgREST.
 * Tabela: escolas
 */

import { postgrestClient } from "../lib/postgrest/client";

/**
 * Serviço de escolas
 */
export const escolasService = {
  /**
   * Lista escolas com filtros
   * @param {Object} options
   * @param {Object} options.filters - Filtros (ex: { ativo: "eq.true" })
   * @param {string} options.order - Ordenação (ex: "nome.asc")
   * @param {number} options.limit - Limite de resultados
   * @param {number} options.offset - Offset para paginação
   * @param {string} options.search - Busca por nome
   * @param {boolean} options.includeCount - Se true, retorna { data, total }
   * @returns {Promise<Array|{data: Array, total: number}>}
   */
  async list(options = {}) {
    const { filters = {}, order = "nome.asc", limit, offset, search, includeCount = false } = options;
    
    let queryFilters = { ...filters };
    
    // Se houver busca, adicionar filtro de busca por nome
    if (search && search.trim() !== "") {
      queryFilters.nome = `ilike.%${search.trim()}%`;
    }
    
    const result = await postgrestClient.get("escolas", {
      filters: queryFilters,
      order,
      limit,
      offset,
      includeCount,
    });
    
    // Se includeCount, retorna { data, total }, senão retorna array direto
    if (includeCount && result && typeof result === 'object' && 'data' in result) {
      return result;
    }
    return result;
  },

  /**
   * Busca escola por ID
   * @param {string} id
   * @returns {Promise<Object>}
   */
  async getById(id) {
    const result = await postgrestClient.get("escolas", {
      filters: { id: `eq.${id}` },
    });
    return Array.isArray(result) ? result[0] : result;
  },

  /**
   * Cria nova escola
   * @param {Object} escolaData
   * @returns {Promise<Object>}
   */
  async create(escolaData) {
    const result = await postgrestClient.post("escolas", escolaData);
    return Array.isArray(result) ? result[0] : result;
  },

  /**
   * Atualiza escola
   * @param {string} id
   * @param {Object} escolaData
   * @returns {Promise<Object>}
   */
  async update(id, escolaData) {
    const result = await postgrestClient.patch("escolas", { id }, escolaData);
    return Array.isArray(result) ? result[0] : result;
  },

  /**
   * Remove escola
   * @param {string} id
   * @returns {Promise<null>}
   */
  async delete(id) {
    return postgrestClient.delete("escolas", { id });
  },
};

export default escolasService;
